import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Standard predunning PaymentFlowLink (Jira/JSM/JPD in predunning with experience URL).
 */
export function isEligibleForJiraStandardPredunning(context: EditionAwarenessContextType): boolean {
	const {
		product,
		edition,
		isInPredunning,
		invoiceableStatus,
		canAddPaymentDetails,
		addPaymentDetailsExperienceUrl,
		isInCollection,
	} = context;

	return Boolean(
		isInCollection === 'NOT_IN_COLLECTION' &&
		isEditionOneOf(edition, ['standard']) &&
		addPaymentDetailsExperienceUrl &&
		isInPredunning &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails &&
		isProductOneOf(product, ['jira', 'jira-service-management', 'jira-product-discovery']),
	);
}
